var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerSelect2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    width: "48px",
    viewBox: "0 0 3320 4730",
    fill: "#ffffff",
    transform: "scale(1,-1)",
    style: {
      transform: "scale(1,-1)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1419 4705 c-457 -74 -839 -310 -1105 -681 -226 -317 -345 -770 -290 -1104 52 -311 238 -728 549 -1230 90 -146 348 -531 433 -647 25 -35 41 -63 35 -63 -5 0 -70 -11 -144 -25 -271 -50 -513 -143 -624 -240 -92 -81 -127 -197 -88 -291 67 -162 329 -290 745 -363 218 -39 364 -52 655 -58 495 -10 885 35 1198 137 326 108 474 259 423 433 -52 177 -339 322 -781 392 -55 9 -110 18 -123 21 -22 4 -20 9 39 92 569 808 878 1407 956 1847 31 178 3 431 -73 663 -184 562 -650 976 -1239 1102 -130 28 -437 36 -566 15z m330 -876 c305 -49 521 -297 523 -599 2 -177 -55 -316 -181 -440 -84 -84 -176 -138 -277 -164 -80 -21 -228 -21 -308 0 -206 53 -387 235 -441 444 -26 98 -17 272 18 362 82 213 261 360 479 397 75 12 114 12 187 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerSelect2);
export default __webpack_public_path__ + "static/media/markerSelect2.83304e62fa88b67468acbf57ad2e26f0.svg";
export { ForwardRef as ReactComponent };